module.exports = __webpack_public_path__ + "img/attempt-warning.7635781f.svg";